import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const ASCII_MOSAIC_PARAMS = [
  {
    kind: 'float',
    key: 'cell',
    label: 'Rasterzelle',
    min: 3,
    max: 90,
    step: 0.5,
    scale: 'log',
    default: 15,
    unit: 'px',
    bulkRange: [7, 34],
    group: 'Raster',
  },
  {
    kind: 'float',
    key: 'aspect',
    label: 'Zellverhältnis',
    min: 0.4,
    max: 2.5,
    step: 0.01,
    default: 1,
    group: 'Raster',
    tooltip: 'Höhe zu Breite der Zelle. Klassische Terminals sind etwa 2.',
  },
  {
    kind: 'text',
    key: 'charset',
    label: 'Zeichensatz',
    default: ' .:-=+*#%@',
    group: 'Raster',
    tooltip: 'Von hell nach dunkel sortiert. Das erste Zeichen steht für leere Fläche.',
    bulkValues: [' .:-=+*#%@', ' ░▒▓█', ' ·+×※▩', ' 123456789', ' /\\|—_'],
  },
  {
    kind: 'enum',
    key: 'mapping',
    label: 'Zuordnung',
    default: 'coverage',
    segmented: true,
    group: 'Raster',
    options: [
      { value: 'coverage', label: 'Deckung' },
      { value: 'distance', label: 'Distanz' },
    ],
    tooltip: 'Deckung folgt der Buchstabenfläche, Distanz erzeugt weiche Höhenschichten.',
  },
  {
    kind: 'float',
    key: 'distanceReach',
    label: 'Distanz-Reichweite',
    min: 5,
    max: 600,
    step: 1,
    scale: 'log',
    default: 120,
    unit: 'px',
    group: 'Raster',
    showIf: (v) => v.mapping === 'distance',
  },

  {
    kind: 'float',
    key: 'fontSize',
    label: 'Zeichengrösse',
    min: 0.3,
    max: 2.5,
    step: 0.01,
    default: 1.15,
    unit: '×',
    group: 'Zeichen',
    tooltip: 'Vielfaches der Zellgrösse.',
  },
  {
    kind: 'float',
    key: 'sizeJitter',
    label: 'Grössenstreuung',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0,
    group: 'Zeichen',
  },
  {
    kind: 'float',
    key: 'rotationJitter',
    label: 'Rotationsstreuung',
    min: 0,
    max: 180,
    step: 1,
    default: 0,
    unit: '°',
    group: 'Zeichen',
  },

  {
    kind: 'bool',
    key: 'background',
    label: 'Hintergrundzeichen',
    default: false,
    group: 'Hintergrund',
    tooltip: 'Füllt auch die Fläche ausserhalb der Buchstaben.',
  },
  {
    kind: 'text',
    key: 'backgroundCharset',
    label: 'Hintergrund-Zeichensatz',
    default: '·.',
    group: 'Hintergrund',
    showIf: (v) => v.background === true,
  },
  {
    kind: 'float',
    key: 'backgroundOpacity',
    label: 'Hintergrund-Deckkraft',
    min: 0.02,
    max: 1,
    step: 0.01,
    default: 0.18,
    group: 'Hintergrund',
    showIf: (v) => v.background === true,
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'density',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'density', label: 'Nach Dichte' },
      { value: 'distance', label: 'Nach Textdistanz' },
      { value: 'random', label: 'Zufällig' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'acid' },
    group: 'Farbe',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 1,
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type AsciiMosaicValues = SchemaValues<typeof ASCII_MOSAIC_PARAMS>;
